(() => {
  const REVEAL_CLASS = 'is-revealed';
  const STAGGER_MS = 80;
  const STAGGER_LIMIT = 3; // solo las primeras 3 sections tienen delay incremental
  const TEMPLATE_SECTION_SELECTOR =
    'main[data-template*="index"] .shopify-section, main[data-template*="collection"] .shopify-section';
  const ATTR_SELECTOR = '[data-reveal]';

  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = () => {
    const templateSections = Array.from(
      document.querySelectorAll(TEMPLATE_SECTION_SELECTOR)
    );
    const explicit = Array.from(document.querySelectorAll(ATTR_SELECTOR));
    const targets = [...templateSections, ...explicit];

    if (!targets.length) return;

    templateSections.forEach((el, i) => {
      if (!el.style.getPropertyValue('--reveal-delay')) {
        const delay = i < STAGGER_LIMIT ? i * STAGGER_MS : 0;
        el.style.setProperty('--reveal-delay', `${delay}ms`);
      }
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add(REVEAL_CLASS));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(REVEAL_CLASS);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -10% 0px' }
    );

    // Doble rAF: garantiza que el browser pinte el frame inicial (oculto)
    // antes de que el observer dispare el primer entry, así la transición se ejecuta.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        targets.forEach((el) => io.observe(el));
      });
    });

    // Safety net: si algo no se reveló en 2.5s, lo revelamos igual.
    setTimeout(() => {
      targets.forEach((el) => {
        if (!el.classList.contains(REVEAL_CLASS)) {
          el.classList.add(REVEAL_CLASS);
        }
      });
    }, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
